import { isValidPhoneNumber } from "libphonenumber-js/min";

const MAX_DIGITS = 15; // E.164, как в legacy

/**
 * Валидация телефона по E.164: 10–15 цифр (как в legacy).
 * @param {string} phone — строка с номером (например "+375291234567" или "+79001234567")
 * @returns {{ valid: boolean, error?: string }}
 */
export function validatePhone(phone, t = (source) => source) {
  const trimmed = (phone || "").trim();
  if (!trimmed) {
    return { valid: false, error: t("Введите номер телефона") };
  }
  const digits = trimmed.replace(/\D/g, "");
  if (digits.length > MAX_DIGITS) {
    return { valid: false, error: t("Слишком длинный номер") };
  }
  if (!isValidPhoneNumber(trimmed)) {
    return { valid: false, error: t("Некорректный номер телефона") };
  }
  return { valid: true };
}
